import { computed, Injectable, signal } from "@angular/core";
import { PermissionStateModel } from "../Dto/PermissionStateModel";
import { Permission } from "../Dto/PermissionModel";

const initialState: PermissionStateModel = {
  data: [],
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class PermissionState {
  private readonly state = signal<PermissionStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setPermissions(data: Permission[]): void {
    this.state.update((state) => ({
      ...state,
      data,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }
}
